<template>
	<div id="recruit-applying">
		<div class="info">
			<van-cell-group>
				<van-field label="姓名" maxlength="15" error-message-align="right" v-model="name" input-align="right" placeholder="请输入姓名" />
				<van-field
					label="年龄"
					maxlength="3"
					error-message-align="right"
					v-model="age"
					input-align="right"
					placeholder="请输入年龄"
					:error-message="ageErrorMessage"
					@blur="isValidAge"
				/>
				<van-field
					label="手机号码"
					maxlength="11"
					error-message-align="right"
					v-model="edtPhone"
					input-align="right"
					placeholder="请输入手机号码"
					:error-message="phoneErrorMessage"
					@blur="isValidPhone"
				/>
				<van-cell is-link @click="change">
					<template slot="title">
						<span class="custom-title">
							<span class="label">学历</span>
							<span class="wheel">{{ edut.text }}</span>
						</span>
					</template>
				</van-cell>
			</van-cell-group>
		</div>
		<div class="file">
			<strong>简历附件</strong>
			<div class="file-image">
				<van-uploader v-model="imgFile" :after-read="afterRead" :max-count="3" preview-size="3.75rem" multiple accept="image/*" />
			</div>
		</div>

		<div id="btn-container">
			<van-button
				@click="submitClick"
				id="btn-submit"
				type="info"
				:disabled="token == '' || imgFile.length < 1 || name.trim() == '' || !isValidAgeFlag || !isValidPhoneFlag || edut.id == null || isUploading"
				block
				>提交
			</van-button>
		</div>

		<van-popup v-model="showPicker" position="bottom">
			<van-picker show-toolbar :columns="columns" @cancel="showPicker = false" @confirm="onConfirm" />
		</van-popup>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
	data() {
		return {
			name: '',
			age: null,
			edtPhone: '',
			imgFile: [],
			edut: '',
			showPicker: false,
			columns: [],
			recruit_id: '',
			uploadImageUrls: [],
			phoneErrorMessage: '',
			ageErrorMessage: '',
			isValidAgeFlag: false,
			isValidPhoneFlag: false,
			isUploading: false,
		}
	},
	computed: {
		...mapGetters(['token', 'userId', 'communityId', 'realname', 'phone']),
	},
	created() {
		this.name = this.realname
		this.edtPhone = this.phone
		this.recruit_id = this.$route.query.id
		this.vaxios.get(
			`${this.vaxios.host}/open/api/v1/properties`,
			{ type: 8, communityId: this.communityId},
			(res) => {
				if (res.msg !== '成功' || !res.data) return
				for (let item of res.data) {
					this.columns.push({ text: item.name, id: item.id })
				}
			},
			function(err) {
				console.log(err)
			},
			{
				headers: {
					Authorization: 'Bearer ' + this.token,
					'Content-Type': 'application/json',
				},
			}
		)
	},

	mounted() {
		if (this.token == '' || !this.token) {
			this.$toast('账号未登录')
		} else {
			this.isValidPhone()
		}
	},

	methods: {
		change() {
			this.showPicker = true
		},
		//手机号码校验
		isValidPhone() {
			var numReg = /^(((13[0-9]{1})|(14[0-9]{1})|(15[0-9]{1})|(16[0-9]{1})|(17[0-9]{1})|(18[0-9]{1})|(19[0-9]{1}))+\d{8})$/
			if (!numReg.test(this.edtPhone)) {
				this.phoneErrorMessage = '非法手机号'
				this.isValidPhoneFlag = false
			} else {
				this.phoneErrorMessage = ''
				this.isValidPhoneFlag = true
			}
		},
		//年龄校验
		isValidAge() {
			let reg = /^(?:[1-9][0-9]?|1[01][0-9]|100)$/ //年龄是1-100之间
			if (!reg.test(this.age)) {
				this.ageErrorMessage = '非法年龄'
				this.isValidAgeFlag = false
			} else {
				this.ageErrorMessage = ''
				this.isValidAgeFlag = true
			}
		},
		// 获取教育程度
		onConfirm(value) {
			this.edut = value
			this.showPicker = false
		},
		//提交简历
		submitClick() {
			this.isUploading = true
			this.vaxios.post(
				`${this.vaxios.host}/api/v1/recruits/apply`,
				{
					community_id: this.communityId,
					recruit_id: String(this.recruit_id),
					age: this.age,
					education_id: this.edut.id,
					attach_list: this.uploadImageUrls,
				},
				(res) => {
					if (res.msg == '成功') {
						this.$toast.success('提交成功')
						let timer = setTimeout(() => {
							this.$router.go(-1)
							clearTimeout(timer)
						}, 600)
					}
					this.isUploading = false
				},
				(e) => {
					console.log(e)
					this.isUploading = false
				},
				{
					headers: {
						Authorization: 'Bearer ' + this.token,
						'Content-Type': 'application/json',
					},
				}
			)
		},

		afterRead(file) {
			var formData = new FormData()
			formData.append('file', file.file)
			this.isUploading = true
			this.vaxios.post(
				`${this.vaxios.host}/api/v1/storages/upload`,
				formData,
				(res) => {
					this.uploadImageUrls.push(res.data)
					this.$toast('上传成功')
					this.isUploading = false
				},
				(e) => {
					console.log('上传失败', e)
					this.isUploading = false
				},
				{
					headers: {
						Authorization: 'Bearer ' + this.token,
						'Content-Type': 'multipart/form-data',
					},
				}
			)
		},
	},
}
</script>

<style scoped>
#body {
	height: 100%;
	background-color: #f6f6f6;
}

#recruit-applying {
	height: 100%;
	background-color: #f6f6f6;
}

.info {
	background-color: #f6f6f6;
	padding-top: 0.75rem;
	font-size: 1rem;
}

.file {
	padding: 2.03125rem 1rem 2.65625rem 1rem;
	background-color: #ffffff;
}

.file strong {
	font-size: 1.25rem;
}

.file-image {
	margin-top: 1.25rem;
}

#btn-container {
	position: absolute;
	bottom: 2.125rem;
	width: 100%;
	text-align: center;
}

#btn-submit {
	width: 91.47%;
	font-size: 1.125rem;
	height: 2.75rem;
	padding: 0;
	margin: 0 auto;
}

.custom-title {
	display: flex;
	justify-content: space-between;
	align-items: center;
}
</style>
